<template>
	<el-dialog
	      width="30%"
	      :title="title"
	      :visible.sync="dialogVisible"
	      :before-close="handleClose">
		<el-form :model="form" ref="form" label-width="100px" class="demo-ruleForm">
		  <el-form-item label="名称" prop="name">
		    <el-input v-model="form.name"></el-input>
		  </el-form-item>
		  <el-form-item label="紧急程度" prop="priority">
		    <el-select v-model="form.priority" clearable placeholder="请选择">
		        <el-option
		          v-for="item in priorityList"
		          :key="item.value"
		          :label="item.name"
		          :value="item.value">
		        </el-option>
		    </el-select>
		  </el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
		  <el-button size="small" @click="dialogVisible = false">取 消</el-button>
		  <el-button size="small" type="primary" @click="save">保 存</el-button>
		</span>		
	</el-dialog>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				title: '',
				callback: undefined,
				form: {
					name: '',
					priority: ''
				},
				dialogVisible: false,
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			priorityList() {
				return this.$store.orderGroupStore.state.priorityList
			},
		},
		watch: {},
		methods: {
			handleClose(done) {
				this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
			},
			closeDialog() {
				this.dialogVisible = false
				this.form = {
					name: '',
					priority: ''
				}
			},
			open(title, data, callback) {
				if(!isempty(data)) {
					this.form = copy(data)
				}
				this.title = title
				this.callback = callback
				this.dialogVisible = true
			},
			save() {
				if(isempty(this.form.name) || isempty(this.form.priority)) {
					this.$message({
						message: '请将信息填写完整后再保存！',
						type: 'warning'
					})
					return
				}
				this.callback(this.form)
				this.closeDialog()
			}
		}
	}
</script>

<style scoped>
	
</style>
